import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-detail',
  templateUrl: './app-detail.component.html',
  styleUrls: ['./app-detail.component.scss']
})
export class AppDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
